import { WtrRootState } from 'redux/create-store';

export const selectBanners = (state: WtrRootState) => state.adtech.byCategory;
export const selectLeaderboard = (state: WtrRootState, searchTerm: string) =>
  state.adtech.bySearchTerm[searchTerm?.toLowerCase()];
export const selectHotspots = (state: WtrRootState) => state.adtech.offers.hotspots;
export const selectOffersLeaderboards = (state: WtrRootState) => state.adtech.offers.leaderboards;
